import styled from 'styled-components'
import { VARIABLES } from '../../themes'

// Wrapper
// ============================================================
export const SupplierDetailFormAdminStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .main-content {
    min-height: calc(100vh - 267px);
  }
  .loading {
    justify-content: center;
    align-items: center;
  }
  .form-group {
    .form-group-control {
      .form-group-inner-wrapper {
        span {
          font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
          color: ${VARIABLES.COLORS.BLUE_1};

          &.approved {
            color: ${VARIABLES.COLORS.GREEN_1};
          }

          &.rejected {
            color: ${VARIABLES.COLORS.RED_3};
          }
        }
      }
    }

    .loader {
      border: 4px solid #3a39a8;
      border-radius: 50%;
      border-top: 4px solid #f3f3f3;
      width: 20px;
      height: 20px;
      -webkit-animation: spin 2s linear infinite; /* Safari */
      animation: spin 2s linear infinite;
    }

    &.sustainaility {
      .form-group-control {
        .form-group-inner-wrapper {
          height: 63px;

          span {
            margin-right: 30px;
            font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
            color: ${VARIABLES.COLORS.BLUE_1};

            &.incomplete {
              color: ${VARIABLES.COLORS.GRAY_9};
            }

            &.complete {
              color: ${VARIABLES.COLORS.GREEN_1};
            }
          }
        }
      }
    }

    &.approve-status {
      .form-group-control {
        .form-group-inner-wrapper {
          align-items: flex-start;
          padding-top: 8px;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

// export const SupplierManagementAdminStyled = styled.div`
//   /* Parent styles
//   ------------------------------- */
//   width: 100%;

//   /* Child element styles
//   ------------------------------- */
//   /* .main-content {
//     min-width: 1600px;
//   } */

//   .table-wrapper {
//     margin-top: 21px;
//   }

//   .table {
//     .table-row {
//       .company-name {
//         flex: 1 1 auto;
//         min-width: 150px;
//       }

//       .main-directory {
//         flex: 0 0 11%;
//         justify-content: center;
//         text-align: center;
//       }

//       .status {
//         flex: 0 0 14%;
//       }

//       .sustainability-pre-assessment {
//         flex: 0 0 12%;
//         justify-content: center;
//         text-align: center;

//         /* hide */
//       }

//       .active {
//         flex: 0 0 9%;
//         justify-content: center;
//         text-align: center;
//       }

//       .actions {
//         flex: 0 0 12%;
//       }
//     }
//   }

//   /* Modifiers
//   ------------------------------- */

//   /* Media queries
//   ------------------------------- */
// `

// export const SupplierManagementBuyerStyled = styled.div`
//   /* Parent styles
//   ------------------------------- */
//   width: 100%;

//   /* Child element styles
//   ------------------------------- */
//   /* .main-content {
//     min-width: 1600px;
//   } */

//   .table-wrapper {
//     margin-top: 21px;
//   }

//   .table {
//     .table-row {
//       .company-name {
//         min-width: 300px;
//         flex: 1 1 auto;
//       }

//       .status {
//         width: 7%;
//         min-width: 95px;
//       }
//     }
//   }

//   /* Modifiers
//   ------------------------------- */

//   /* Media queries
//   ------------------------------- */
// `
